import HttpClient from '@/utility/http-client';
import { Customer } from '@/models/customer';
import { Auth } from '@/models/auth';
import { Forgot } from '@/models/forgot';
import authProvider from '@/utility/authProvider';
import localStorage from '@/utility/localStorage';

export default {
    register(dataRequest: Customer) {
        return HttpClient.instance().put(`/api/customers/`, dataRequest);
    },

    sendOtp(dataRequest: any) {
        return HttpClient.instance().post(`/api/customers/send_otp/`, dataRequest);
    },

    login(dataRequest: Auth) {
        return HttpClient.instance().post(`/api-token-auth/`, dataRequest);
    },
    
    logout(dataRequest: Auth) {
        return HttpClient.instance().post(`/api/logout/`, dataRequest);
    },

    forgot(dataRequest: Forgot) {
        return HttpClient.instance().post(`/api/forgot-pwd/`, dataRequest);
    },

    async verifyToken() {
        try {
            if (authProvider.isToken()) {
                const dataRequest = {
                    token: authProvider.getToken(),
                    FirebaseToken: localStorage.get('FCM_Token')
                };
                return await HttpClient.instance().post(`/api-token-verify/`, dataRequest);
            }
            return false;
        } catch (err) {
            return false;
        }
    },

    async customersInfo(customerId: number) {
        return HttpClient.instance().get(`/api/customers/${customerId}`);
    },

    async updateCustomersInfo(customerId: number, dataRequest: any) {
        return HttpClient.instance().post(`/api/customers/${customerId}`, dataRequest);
    },

    async verifyEmail(dataRequest: any) {
        return HttpClient.instance().post(`/api/customers/verify/`, dataRequest);
    }
};
